import {useMutation, useQuery} from '@tanstack/react-query';

import {RQ_LABORATORY_ADD_TEST_API, RQ_LABORATORY_CREATE_API, RQ_LABORATORY_DELETE_API, RQ_LABORATORY_LOOKUP_API, RQ_LABORATORY_LOOKUP_ID_API, RQ_LABORATORY_REPORT_API, RQ_USER_LOOKUP_ROLE_API} from './Constants/LaboratoryAPIConstant';
import {rqCreateRequest} from './rqHttpUtils';

const withUrl = (config, key, value) => ({
  ...config,
  url: config.url.replace(`<%= ${key} %>`, value),
});

// Create Laboratory
export const RQLaboratoryCreateAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_create_laboratory'],
    mutationFn: async ({formData, token}) => {
      if (!formData) {
        throw new Error('formData is undefined');
      }

      return rqCreateRequest(
        RQ_LABORATORY_CREATE_API,
        formData,
        token,
        null,
      );
    },
    ...options,
  });

// Add Test
export const RQLaboratoryAddTestAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_add_lab_test'],
    mutationFn: async ({id, formData, token}) =>
      rqCreateRequest(
        withUrl(RQ_LABORATORY_ADD_TEST_API, 'id', id),
        formData,
        token,
        null,
      ),
    ...options,
  });

// Update Report
export const RQLaboratoryReportAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_update_lab_report'],
    mutationFn: async ({id, formData, token}) =>
      rqCreateRequest(
        withUrl(RQ_LABORATORY_REPORT_API, 'id', id),
        formData,
        token,
        null,
      ),
    ...options,
  });

// Lookup All Laboratories
export const RQLaboratoryLookupAPI = (
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_laboratories'],
    queryFn: () =>
      rqCreateRequest(
        RQ_LABORATORY_LOOKUP_API,
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!token,
    ...options,
  });

// Lookup Laboratory By Id
export const RQLaboratoryLookupByIdAPI = (
  id,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_laboratory', id],
    queryFn: () =>
      rqCreateRequest(
        withUrl(RQ_LABORATORY_LOOKUP_ID_API, 'id', id),
        null,
        token,
        null,
      ),
    enabled: !!id && !!token,
    ...options,
  });

// Delete Laboratory
export const RQDeleteLaboratoryAPI = (callbacks = {}) =>
  useMutation({
    mutationKey: ['rq_delete_laboratory'],
    mutationFn: ({id, token}) =>
      rqCreateRequest(
        withUrl(RQ_LABORATORY_DELETE_API, 'id', id),
        null,
        token,                 
        null,
      ),
    ...callbacks,
  });

// User Lookup By Role
export const RQUserLookupRoleAPI = (
  role,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_users', role],
    queryFn: () =>
      rqCreateRequest(
        withUrl(RQ_USER_LOOKUP_ROLE_API, 'role', role),
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!role && !!token,
    ...options,
  });
